import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { FiMail } from "react-icons/fi";
import { Formik } from "formik";
import { MdClose, MdLocalPhone } from "react-icons/md";
import { toast } from "react-toastify";

import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import api from "services/api";
import { cellPhoneNumberRegex } from "utils/regex";

import axios, { Method } from "axios";
import {
  ContentField,
  Field,
  FormContainer,
  FormRadio,
  FormRadioContent,
  ModalContainer,
  ModalHeader,
  ModalStyle,
  Paragraph,
  SelectTypeValidation,
  Title,
} from "./styles";
import { getAccessToken } from "services/accessTokenServices";

const ValidationContact = ({
  document,
  userId,
  show,
  handleCloseModal,
  tokenQuestions,
  setStepSideBar,
  setContactId,
}: any): JSX.Element => {
  const [step, setStep] = useState("validationOption");
  const [startTimer, setStartTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectTypeValidation, setSelectTypeValidation] = useState("email");
  const [accessToken, setAccessToken] = useState("");
  const [siteId, setSiteId] = useState("");
  const [customerCode, setCustomerCode] = useState("");

  const intervalRef = useRef();

  useEffect(() => {
    if (startTimer) {
      // @ts-ignore
      intervalRef.current = setInterval(decreaseNum, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [startTimer]);

  const sendToken = async (type, value): Promise<any> => {
    try {
      const access_token = (await getAccessToken()) || "";
      const headers = {
        access_token,
      };
      const bodyCreteContact = {
        contact: value,
        contactType: type,
        siteId,
        document,
        token: tokenQuestions,
      };

      const result = await api.post(
        `industrial/customer/v1/users/${userId}/contacts`,
        bodyCreteContact,
        {
          headers,
        }
      );
      const contactIdResponse = result.headers.location.split("/").pop();

      setContactId(contactIdResponse);

      const bodyToken = {
        tokenType: "CHANGE_PASSWORD",
        url: "",
        contactId: contactIdResponse,
        document,
        customerCode,
      };

      const responseToken = await api.post(
        `industrial/customer/v1/users/${userId}/tokens`,
        bodyToken
      );

      toast.warn(`Enviamos um código de verificação para ${value}`);
      return responseToken;
    } catch (err) {
      const erro = err.response;

      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
      return false;
    }
  };

  const handlerSubmitEmail = async (data): Promise<void> => {
    setLoading(true);
    await sendToken("EMAIL", data.email);
    setStepSideBar(3);
    setStartTimer(true);
    setLoading(false);
  };

  const handlerSubmitPhone = async (data): Promise<void> => {
    setLoading(true);
    const value = data.phoneNumber.replace(/[^\d]/g, "");
    await sendToken("PHONE", value);
    setStepSideBar(3);
    setStartTimer(true);
    setLoading(false);
  };

  const resetStep = (): void => {
    setStep("validationOption");
    setStartTimer(false);
  };

  const onHide = (): void => {
    handleCloseModal();
    resetStep();
  };

  const validatorSchemaEmail = (): any =>
    Yup.object().shape({
      email: Yup.string()
        .email("E-mail inválido")
        .required("É necessário um e-mail"),
    });

  const validatorSchemaPhone = (): any =>
    Yup.object().shape({
      phoneNumber: Yup.string()
        .required("É necessário digitar seu número de celular")
        .test("Telefone", "Número de telefone inválido", (value) => {
          if (value) {
            value = value.replace(/[^\d]/g, "");
            return !!value.match(cellPhoneNumberRegex);
          }
          return null;
        }),
    });

  const generateAccessToken = async (): Promise<void> => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: "POST" as Method,
      headers: header,
    };
    const body = {
      grant_type: "client_credentials",
    };

    try {
      const result = await req.post("oauth/access-token", body, parameters);

      setAccessToken(result.data.access_token);
    } catch (err) {
      const message =
        err.response.data[0]?.message || err.response.data.message;

      toast.error(message);
    }
  };

  const getSiteId = async (): Promise<void> => {
    try {
      const response = await api.get(
        `industrial/customer/v1/customers?type=MI&document=${document}`,
        {
          headers: {
            access_token: accessToken,
          },
        }
      );
      if (response?.data) {
        const [customer] = response.data;
        const { customerCode } = customer;
        const { customerAddresses } = customer;
        const [customerAddressesFiltered] = customerAddresses.filter(
          ({ main }) => main === true
        );

        if (
          !customerAddressesFiltered ||
          customerAddressesFiltered?.length === 0
        ) {
          return;
        }

        const { siteId: siteIdResponse } = customerAddressesFiltered;

        setCustomerCode(customerCode);
        if (siteIdResponse) {
          setSiteId(siteIdResponse);
        }
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    (async () => {
      await generateAccessToken();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!accessToken) return;
      await getSiteId();
    })();
  }, [accessToken]);

  return (
    <ModalStyle
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalContainer>
        <ModalHeader>
          <Title>Dados cadastrais</Title>
          {step !== "validationToken" && (
            <MdClose size={24} onClick={handleCloseModal} />
          )}
        </ModalHeader>
        <Paragraph>
          Valide pelo <b>menos um de seus contatos</b> pessoais
        </Paragraph>

        {step === "validationOption" && (
          <div>
            <SelectTypeValidation>
              <FormRadioContent>
                <FormRadio
                  custom
                  type="radio"
                  id="email"
                  name="type"
                  label="Email"
                  isSelect={selectTypeValidation === "email"}
                  onClick={() => setSelectTypeValidation("email")}
                />
                <FormRadio
                  custom
                  type="radio"
                  id="phone"
                  name="type"
                  label="Celular"
                  isSelect={selectTypeValidation === "phone"}
                  onClick={() => setSelectTypeValidation("phone")}
                />
              </FormRadioContent>
            </SelectTypeValidation>
            {selectTypeValidation === "email" && (
              <Formik
                initialValues={{
                  email: "",
                }}
                onSubmit={handlerSubmitEmail}
                validationSchema={validatorSchemaEmail}
                render={({
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => (
                  <FormContainer>
                    <span>Um código será enviado no email informado</span>
                    <ContentField>
                      <Field>
                        <TextField
                          LeadingIcon={FiMail}
                          propsLeadingIcon={{
                            size: 24,
                          }}
                          type="text"
                          name="email"
                          label="Email *"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          errorCondition={!!errors.email && !!touched.email}
                          errorMessage={`${errors.email}`}
                          disabled={loading}
                        />
                      </Field>
                      <OutlinedButton
                        type="submit"
                        disabled={!values.email || !!errors.email || loading}
                      >
                        Enviar token
                      </OutlinedButton>
                    </ContentField>
                  </FormContainer>
                )}
              />
            )}
            {selectTypeValidation === "phone" && (
              <Formik
                initialValues={{
                  phoneNumber: "",
                }}
                onSubmit={handlerSubmitPhone}
                validationSchema={validatorSchemaPhone}
                render={({
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                }) => (
                  <FormContainer>
                    <span>Um código será enviado no celular informado</span>
                    <ContentField>
                      <Field>
                        <TextField
                          LeadingIcon={MdLocalPhone}
                          propsLeadingIcon={{
                            size: 24,
                          }}
                          name="phoneNumber"
                          mask="(99) 9 9999-9999"
                          label="Celular com DDD *"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phoneNumber}
                          errorCondition={
                            !!errors.phoneNumber && !!touched.phoneNumber
                          }
                          errorMessage={`${errors.phoneNumber}`}
                          disabled={loading}
                        />
                      </Field>
                      <OutlinedButton
                        type="submit"
                        disabled={
                          !values.phoneNumber || !!errors.phoneNumber || loading
                        }
                      >
                        Enviar token
                      </OutlinedButton>
                    </ContentField>
                  </FormContainer>
                )}
              />
            )}
          </div>
        )}
      </ModalContainer>
    </ModalStyle>
  );
};

export default ValidationContact;
